import React from 'react';
import { connect } from 'react-redux';
import Label from "../Labels/Label";
import ButtonsContent from "../Buttons/ButtonsContent";

import "./Room.css";

const VideoCall = ({ isRoomListener }) => {
    return (!isRoomListener) ? (
        <div className='row mb-2 room_video_portal_container'>
            <Label text="VÍDEO CHAMADA" />

            <div className='col-md-12 mb-2'>
                <div id='id_video_portal'></div>
            </div>

            <div className='col-md-12 mb-2'>
                <ButtonsContent />
            </div>
        </div>
    ) : null;
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(VideoCall);